import { render, staticRenderFns } from "./ImageCTAHeader.vue?vue&type=template&id=65888208"
import script from "./ImageCTAHeader.vue?vue&type=script&lang=ts"
export * from "./ImageCTAHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports